module.exports = __webpack_public_path__ + "static/media/abertown-logo-white.9bda5f7c.jpg";